import React from 'react';
import { IAppliedFilter, IFilterableField } from './filters';
import Modal from 'react-bootstrap/Modal';
import { useModalState } from 'v2/hooks/useModalState';
import styles from './FiltersModal.module.scss';
import closeIcon from 'v2/icons/close-icon.svg';
import { FiltersModalContent } from './FiltersModalContent/FiltersModalContent';

type TModalStateProps = ReturnType<typeof useModalState>;

interface IFiltersModalProps extends TModalStateProps {
  filterableFields: IFilterableField[];
  filters: IAppliedFilter[];
  onFiltersChanged: (newAppliedFilters: IAppliedFilter[]) => void;
}

export const FiltersModal = ({
  filterableFields,
  show,
  filters,
  handleHide,
  handleShow,
  onFiltersChanged,
}: IFiltersModalProps) => {
  return (
    <Modal show={show} onHide={handleHide} onShow={handleShow}>
      <div className={styles.header}>
        <div className="title">Filters</div>
        <img onClick={handleHide} src={closeIcon} alt="close" />
      </div>
      <div className={styles.content}>
        <FiltersModalContent
          filterableFields={filterableFields}
          filters={filters}
          onFiltersChanged={onFiltersChanged}
        />
      </div>
    </Modal>
  );
};
